<template>
  <div
    :class="$style.container"
    @click="open = true"
    @mouseenter="noHover = true"
    @mouseleave="((noHover = false), (open = false))"
  >
    <a :class="[noHover && $style.noHover, open && $style.open, $style.select]">
      <span>Hydraulikaggregate</span>
      <span :class="$style.triangle" />
    </a>
    <ul>
      <li>
        <a href="#">Hydraulikaggregate</a>
      </li>
      <li :class="[$style.active, 'active']">
        <a href="#">Schmiersysteme</a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const open = ref(false);
const noHover = ref(false);
</script>

<style module lang="scss">
@forward './NaviSelect.scss';
</style>
